import React from 'react';
import { CockpitButton } from 'components/views/atoms/CockpitButton';
import { faCircle, faStopCircle } from '@fortawesome/free-solid-svg-icons';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { keyframes } from '@emotion/react';

export type RecordingButtonProps = {
    recording: boolean;
    size?: SizeProp;
    disabled?: boolean;
    onClick?: () => void;
}

const ringing = keyframes({
    from: {
        color: 'red',
    },
    to: {
        color: 'white',
    }
});

function useIconFromState(recording: boolean) {
    return recording
        ? { icon: faStopCircle, color: 'red', animation: `${ringing} 1s ease alternate infinite` }
        : { icon: faCircle, color: 'red' }
        ;
}

export const RecordingButton = (props: RecordingButtonProps) => {
    const { recording, disabled, ...otherProps } = props;

    const { icon, color, animation } = useIconFromState(recording);

    return (
        <CockpitButton icon={icon} color={disabled ? undefined : color} animation={animation} disabled={disabled} {...otherProps} />
    );
};
